import {assert} from 'Asserts';
import BenchlingConfig from 'BenchlingConfig';

import {DataPolicy, SchemaPolicy} from './PolicyConstants';

export function getDefaultDataPolicy<T extends Pick<DataPolicy, 'isDefault'>>(dataPolicies: Array<T>): T {
  const policy = dataPolicies.find((dataPolicy) => dataPolicy.isDefault);
  assert(policy != null, 'No default policy found.');
  return policy;
}

export function getAdminDataPolicy(dataPolicies: Array<DataPolicy>): DataPolicy {
  const policy = dataPolicies.find((dataPolicy) => dataPolicy.isAdmin);
  assert(policy != null, 'No admin policy found.');
  return policy;
}

export function getAdminSchemaPolicy(schemaPolicies: Array<SchemaPolicy>): SchemaPolicy {
  assert(BenchlingConfig.PERMISSIONS_DEFAULT_SCHEMA_POLICIES != null, 'No default schema policies');
  const policy = schemaPolicies.find(
    (schemaPolicy) => schemaPolicy.id === BenchlingConfig.PERMISSIONS_DEFAULT_SCHEMA_POLICIES.admin_policy_id
  );
  assert(policy != null, 'No admin schema policy found.');
  return policy;
}
